import { Component, Input, OnInit } from '@angular/core';
import { JobPosting } from '@app/models/recruiting/job-posting.model';
import moment from 'moment';
import { EmploymentTypeDisplayOptions } from '@app/types/translatables/employment-type-display.options';

@Component({
    selector: 'app-job-posting-reports-overview-card',
    templateUrl: './job-posting-reports-overview-card.template.html',
    styleUrls: ['./job-posting-reports-overview-card.style.scss'],
})
export class JobPostingReportsOverviewCardComponent implements OnInit {
    @Input() jobPosting: JobPosting;

    jobPostingAge = 0;

    employmentTypeDisplay = EmploymentTypeDisplayOptions;

    ngOnInit(): void {
        this.jobPostingAge = moment().diff(moment(this.jobPosting.createdAt), 'days');
    }
}
